/**
 * Every route v2 declares, one line per file (API_ACCESS.md §3.1): adding a segment is one line
 * here, adding a route none. One route, one declaration: a key declared twice throws when this
 * module loads, which every route test does.
 */
import type { Route } from "../route";
import { ANALYTICS } from "./analytics";
import { CATALOG } from "./catalog";
import { COUPON } from "./coupon";
import { CUSTOMER } from "./customer";
import { ENTITY } from "./entity";
import { ITEM } from "./item";
import { OPTIONSET } from "./optionset";
import { PROGRAM } from "./program";
import { SALE } from "./sale";

export { ANALYTICS, CATALOG, COUPON, CUSTOMER, ENTITY, ITEM, OPTIONSET, PROGRAM, SALE };

/** file name → its routes; the snapshot test checks each route sits in its first segment's file */
export const ROUTE_FILES: Readonly<Record<string, Record<string, Route<any, any, any>>>> = {
  analytics: ANALYTICS,
  catalog: CATALOG,
  coupon: COUPON,
  customer: CUSTOMER,
  entity: ENTITY,
  item: ITEM,
  optionset: OPTIONSET,
  program: PROGRAM,
  sale: SALE,
};

function collect(): readonly Route<any, any, any>[] {
  const byKey = new Map<string, string>();
  const all: Route<any, any, any>[] = [];
  for (const [file, routes] of Object.entries(ROUTE_FILES)) {
    for (const [name, declared] of Object.entries(routes)) {
      const first = byKey.get(declared.key);
      if (first) throw new Error(`api: ${declared.key} is declared twice (${first} and ${file}.${name})`);
      byKey.set(declared.key, `${file}.${name}`);
      all.push(declared);
    }
  }
  return all;
}

/** every declared route, in file order */
export const ALL_ROUTES = collect();
